import { gql } from 'apollo-boost'
// import { Mutation } from 'react-apollo'

export const getUserGroups = gql`
  {
    userGroups {
      name
      id
      groupMembers {
        id
        name
        weight
      }
      description
    }
  }
`
